module.exports = __webpack_public_path__ + "img/deviceBorrow-mine-bar-3.718483f9.png";